import { QueryFactory } from "../../../../Common";
import { BS } from "../../../../Contracts";
export const QCalculateBets = QueryFactory(BS.QueryTypes.CalculateBets);
//# sourceMappingURL=QCalculateBets.js.map